module.exports = __webpack_public_path__ + "4f648368c2ac5d95d2c67f690639e5a6.png";